import AuthorizedLayout from "components/v2/components/Layouts/AuthorizedLayout"
import { Language } from "components/v2/constants/enums"
import { ReactElement } from "react"

const getDefaultLayout = (page: ReactElement, language: Language) => {
    return <AuthorizedLayout language={language}>{page}</AuthorizedLayout>
}

export default getDefaultLayout
